/**
 * AvatarDisplay Styles
 * Styles for the AvatarDisplay component
 */

import { StyleSheet } from 'react-native';
import { theme } from '../../../theme';

export const avatarDisplayStyles = StyleSheet.create({
  container: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  ghostContainer: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.gray[300],
    borderRadius: 999,
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 48,
    minHeight: 48,
  },
  ghostText: {
    fontSize: 24,
    fontWeight: 'bold',
    color: theme.gray[600],
  },
  childrenContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
});

